import { render, staticRenderFns } from "./MoblieFalied.vue?vue&type=template&id=555ff8f6&scoped=true&"
import script from "./MoblieFalied.vue?vue&type=script&lang=js&"
export * from "./MoblieFalied.vue?vue&type=script&lang=js&"
import style0 from "./MoblieFalied.vue?vue&type=style&index=0&id=555ff8f6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "555ff8f6",
  null
  
)

export default component.exports